<div class="filter_menu">
  <h2><i class="bi bi-funnel"></i> Filters</h2>
  <div class="filter_section">
    <div class="input_group mb-3">
      <label><i class="bi bi-search me-1"></i> Zoek op naam</label>
      <input type="text" (input)="onInputChange()" [(ngModel)]="inputValue">
    </div>
    <!--<h3>Waar is het evenement</h3>
    <div class="input_group">
      <label><i class="bi bi-geo-alt me-1"></i> Locatie</label>
      <input type="text">
    </div>
    <div class="input_group">
      <p>
        Afstand
      </p>
      <select name="" id="">
        <option selected value="0">Alle afstanden</option>
        <option value="1">< 5km</option>
        <option value="2">< 10km</option>
        <option value="3">< 15km</option>
        <option value="4">< 20km</option>
        <option value="5">< 25km</option>
        <option value="6">< 50km</option>
      </select>
    </div>
  </div>-->
  <div class="filter_section">
    <h3>
      Activiteitsoort
    </h3>
    <ul>
      <li *ngFor="let eventType of eventTypes">
        <input type="checkbox" id="{{ eventType.tag }}" (change)="toggleEventType(eventType.tag)" [checked]="typeValue === eventType.tag">
        <label for="{{ eventType.tag }}">
          <div class="img"><img src="assets/img/icons/{{ eventType.tag }}.svg" alt=""></div>
          <p>{{ eventType.name }}</p>
        </label>
      </li>
    </ul>
  </div>
  <div class="filter_section">
    <h3>
      Doelgroep
    </h3>
    <ul>
      <li *ngFor="let disabilityType of disabilityTypes">
        <input type="checkbox" (change)="toggleDisabilityType(disabilityType.tag)">{{ disabilityType.long }}
      </li>
    </ul>
  </div>
  <!--<div class="filter_section">
    <h3>
      Hoeveel deelnemers
    </h3>
    <p>Minimaal</p>
    <div class="slider">
      <span class="start">10</span>
      <input type="range" min="10" max="200" value="50" class="slider">
      <span class="start">200</span>
    </div>
    <p>Maximaal</p>
    <div class="slider">
      <span class="start">40</span>
      <input type="range" min="40" max="200" value="80" class="slider">
      <span class="start">200</span>
    </div>
  </div>
  <div class="filter_section">
    <h3>Dagdeel</h3>
    <ul>
      <li><input type="checkbox" name="">Ochtend</li>
      <li><input type="checkbox" name="">Middag</li>
      <li><input type="checkbox" name="">Avond</li>
      <li><input type="checkbox" name="">Nacht</li>
    </ul>
  </div>-->
  </div>
</div>
<button class="filter-button" mat-raised-button *ngIf="hide_small" (click)="closeFilterDrawer()">
  <i class="bi bi-sliders me-1"></i> Filter activiteiten
</button>
